import TextField from '@material-ui/core/TextField'
import React from 'react'
import { controlHasError } from '../../lib/errorHandler'
import ExpandablePanel from '../controls/ExpandablePanel'
import LabelCheckbox from '../controls/LabelCheckbox'
import AnimateHeight from 'react-animate-height'
import ZasadyRachunkowosciStyle from '../../styles/ZasadyRachunkowosciStyle'
import PrintText from '../../lib/PrintText'

class OpisKryteriowObjeciaSprFin extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: props.data.OpisKryteriowObjeciaSprFin ? true : false,
    }
  }
  render() {
    const { data, errors, onSetSectionData, czyPodsumowanie } = this.props
    return (
      <ZasadyRachunkowosciStyle>
        <ExpandablePanel title="KRYTERIA ZASTOSOWANE PRZEZ JEDNOSTKĘ DOMINUJĄCĄ DO OBJĘCIA SPRAWOZDANIEM FINANSOWYM JEDNOSTEK ZALEŻNYCH">
          <form autoComplete="off" className="subsection">
            <LabelCheckbox
              label="Dołącz informację na temat kryteriów zastosowanych przez jednostkę dominującą do objęcia skonsolidowanym sprawozdaniem finansowym jednostek zależnych"
              name="CzyZastosowanoKryteria"
              value={this.state.checked}
              change={(e) => this.setState({ checked: e.target.checked })}
            />
            {!czyPodsumowanie ? (
              <AnimateHeight
                duration={250}
                height={this.state.checked ? 'auto' : 0}
              >
                <TextField
                  className="textarea"
                  error={controlHasError(errors, 'OpisKryteriowObjeciaSprFin')}
                  name="OpisKryteriowObjeciaSprFin"
                  label="Opis kryteriów"
                  multiline
                  variant="outlined"
                  title={data.OpisKryteriowObjeciaSprFin}
                  defaultValue={data.OpisKryteriowObjeciaSprFin}
                  onBlur={(e) =>
                    onSetSectionData(
                      'OpisKryteriowObjeciaSprFin',
                      e.target.value,
                    )
                  }
                />
              </AnimateHeight>
            ) : (
              this.state.checked && (
                <PrintText
                  text={data.OpisKryteriowObjeciaSprFin}
                />
              )
            )}
          </form>
        </ExpandablePanel>
      </ZasadyRachunkowosciStyle>
    )
  }
}

export default OpisKryteriowObjeciaSprFin
